const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="demo-u-space-directions">
  <div>
    <div class="u-space-n3 u-space-1@s u-space-3@m u-space-6@l">u-space-n3 u-space-1@s u-space-3@m u-space-6@l</div>
  </div>
</div>
`);
            }

            getTemplateName() {
                return `0a674759df514e5417e675d328b5c2feb706feb6525717760280586a080acd01`;
            }

            getSourceContext() {
                return new this.Source(``, `0a674759df514e5417e675d328b5c2feb706feb6525717760280586a080acd01`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '0a674759df514e5417e675d328b5c2feb706feb6525717760280586a080acd01');

let template = env.loadTemplate('0a674759df514e5417e675d328b5c2feb706feb6525717760280586a080acd01');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/utilities/spacing/demo/responsive.twig", args: context }
     );
     return rendered;;
};